var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVenuPre7(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3706 12.7078C25.3706 17.603 21.4734 21.5714 16.6659 21.5714C11.8584 21.5714 7.96118 17.603 7.96118 12.7078L7.96118 3.84416L11.2773 3.84416L11.2773 12.7078C11.2773 15.7382 13.6898 18.1948 16.6659 18.1948C19.6419 18.1948 22.0545 15.7382 22.0545 12.7078L22.0545 3.84416L25.3706 3.84416L25.3706 12.7078Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1115 24.0195C11.1115 25.3715 10.0351 26.4675 8.7073 26.4675C7.37952 26.4675 6.30314 25.3715 6.30314 24.0195C6.30314 22.6675 7.37952 21.5714 8.7073 21.5714C10.0351 21.5714 11.1115 22.6675 11.1115 24.0195Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8678 24.0195C25.8678 25.3715 24.7915 26.4675 23.4637 26.4675C22.1359 26.4675 21.0595 25.3715 21.0595 24.0195C21.0595 22.6675 22.1359 21.5714 23.4637 21.5714C24.7915 21.5714 25.8678 22.6675 25.8678 24.0195Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96635 18.9545C6.96635 20.3066 5.88998 21.4026 4.5622 21.4026C3.23442 21.4026 2.15804 20.3066 2.15804 18.9545C2.15804 17.6025 3.23442 16.5065 4.5622 16.5065C5.88998 16.5065 6.96635 17.6025 6.96635 18.9545Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.671 18.9545C31.671 20.3066 30.5946 21.4026 29.2668 21.4026C27.939 21.4026 26.8627 20.3066 26.8627 18.9545C26.8627 17.6025 27.939 16.5065 29.2668 16.5065C30.5946 16.5065 31.671 17.6025 31.671 18.9545Z",
    fill: "#222222"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30831 12.2013C5.30831 13.5533 4.23194 14.6494 2.90416 14.6494C1.57638 14.6494 0.5 13.5533 0.5 12.2013C0.5 10.8493 1.57638 9.75325 2.90416 9.75325C4.23194 9.75325 5.30831 10.8493 5.30831 12.2013Z",
    fill: "#222222"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 12.2013C32.5 13.5533 31.4236 14.6494 30.0958 14.6494C28.7681 14.6494 27.6917 13.5533 27.6917 12.2013C27.6917 10.8493 28.7681 9.75325 30.0958 9.75325C31.4236 9.75325 32.5 10.8493 32.5 12.2013Z",
    fill: "#222222"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30831 5.44805C5.30831 6.80007 4.23194 7.8961 2.90416 7.8961C1.57638 7.8961 0.5 6.80007 0.5 5.44805C0.5 4.09603 1.57638 3 2.90416 3C4.23194 3 5.30831 4.09603 5.30831 5.44805Z",
    fill: "#222222"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 5.44805C32.5 6.80007 31.4236 7.8961 30.0958 7.8961C28.7681 7.8961 27.6917 6.80007 27.6917 5.44805C27.6917 4.09603 28.7681 3 30.0958 3C31.4236 3 32.5 4.09603 32.5 5.44805Z",
    fill: "#222222"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5726 26.5519C18.5726 27.904 17.4963 29 16.1685 29C14.8407 29 13.7643 27.904 13.7643 26.5519C13.7643 25.1999 14.8407 24.1039 16.1685 24.1039C17.4963 24.1039 18.5726 25.1999 18.5726 26.5519Z",
    fill: "#222222"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenuPre7);
export default __webpack_public_path__ + "static/media/venuPre7.41708440c83057ede55867b5bfbb623b.svg";
export { ForwardRef as ReactComponent };